import React from "react";

/**
 * Terms acceptance for new-account magic/password signup.
 * Returning users who already accepted can ignore this on magic-link login.
 */
export default function AuthTermsCheckbox({
  terms,
  setTerms,
  /** signup: create-account framing; signin: optional for first magic use */
  variant = "signup",
}) {
  const lead =
    variant === "signin"
      ? "If this is a new workspace, I accept the "
      : "I accept the ";

  return (
    <label className="flex items-start gap-2 text-xs leading-relaxed text-slate-600">
      <input
        type="checkbox"
        checked={Boolean(terms)}
        onChange={(e) => setTerms?.(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-slate-300 text-blue-700 focus:ring-blue-500"
      />
      <span>
        {lead}
        <a
          href="https://decisionpen.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 underline hover:text-blue-600"
        >
          Terms
        </a>{" "}
        and{" "}
        <a
          href="https://decisionpen.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-700 underline hover:text-blue-600"
        >
          Privacy Policy
        </a>
        {variant === "signin"
          ? ". Existing accounts can continue without re-accepting."
          : "."}
      </span>
    </label>
  );
}
